// extracted by mini-css-extract-plugin
export default {"wrapper":"Versions_wrapper__RrjKm","textWrapper":"Versions_textWrapper__IuTQ1","versionType":"Versions_versionType__aqMPd"};